import React from 'react';
import { BookOpenIcon, DownloadIcon, ArrowRightIcon } from 'lucide-react';
export function LatestCatalogue() {
  return <section className="py-16 bg-white" data-id="element-225">
      <div className="container-wide" data-id="element-226">
        <div className="bg-gradient-to-br from-brand-blue-50 via-white to-brand-green-50 rounded-[2rem] overflow-hidden shadow-elevated border border-gray-100" data-id="element-227">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center" data-id="element-228">
            {/* Catalogue Image */}
            <div className="relative p-8 lg:p-12 flex justify-center" data-id="element-229">
              <div className="relative group cursor-pointer" data-id="element-230">
                <div className="absolute -inset-4 bg-brand-blue/5 rounded-2xl blur-xl group-hover:bg-brand-blue/10 transition-colors" data-id="element-231"></div>
                <img src="https://cdn.magicpatterns.com/uploads/u524sSmzD5AJS9hCU25dVL/image.png" alt="Better Pets and Gardens Latest Catalogue — Huge Easter Savings" className="relative rounded-xl shadow-elevated max-h-[450px] object-contain transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-232" />
                <div className="absolute top-4 right-4 bg-red-600 text-white px-3 py-1.5 rounded-full text-sm font-bold shadow-md animate-pulse" data-id="element-233">
                  NEW
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-8 lg:p-12 lg:pl-4" data-id="element-234">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-blue-50 text-brand-blue text-sm font-bold mb-6" data-id="element-235">
                <BookOpenIcon className="w-4 h-4" data-id="element-236" />
                Latest Catalogue
              </div>
              <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4 leading-tight" data-id="element-237">
                Huge Easter Savings
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-238">
                Browse our latest catalogue packed with incredible deals on
                premium pet food, garden essentials, and pool care. On sale now
                across all 6 stores.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-239">
                <button className="btn-primary py-4 px-8 text-lg shadow-blue-glow flex items-center justify-center gap-2" data-id="element-240">
                  <BookOpenIcon className="w-5 h-5" data-id="element-241" />
                  Browse Catalogue
                </button>
                <button className="btn-secondary bg-white py-4 px-8 text-lg flex items-center justify-center gap-2" data-id="element-242">
                  <DownloadIcon className="w-5 h-5" data-id="element-243" />
                  Download PDF
                </button>
              </div>

              <p className="text-sm text-gray-500 font-medium" data-id="element-244">
                On sale Tuesday 24 March 2026. Available at all stores while
                stocks last.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}